import React from 'react';
import { motion } from 'framer-motion';
const components = ['Component 1 — Volume 1: Foundations, Grooves & Body Control', 'Component 2 — Volume 2: Footwork, Steps & Skill Progressions', 'Component 3 — Volume 3: Combinations, Freestyle & Choreography', 'Component 4 — Volume 4: Performance, Class Planning & Instructor System', 'Component 5 — The 5 Strategic Bonuses that support every class you teach', 'Component 6 — The Full Instructor Toolkit: Class Finder, tracking sheets, planners, time formats, and evaluation tools'];
export function SixInOne() {
  return <section className="py-24 px-4 bg-cream" data-id="element-257" data-mp="2421wc4tifjyd">
      <div className="max-w-4xl mx-auto" data-id="element-258" data-mp="240792jurnfr4">
        <div className="text-center mb-10" data-id="element-259" data-mp="290vc63w9rn1p">
          <h2 className="text-3xl md:text-4xl font-serif font-bold uppercase mb-4 text-ink" data-id="element-260" data-mp="291o8sc1ikw64">
            What makes it a 6-in-1 system?
          </h2>
          <p className="text-lg text-ink-soft max-w-2xl mx-auto" data-id="element-261" data-mp="3kg1tj80z0vhx">
            You don't just get 100 classes. You get 6 complete components that
            work together as one unified teaching system:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-4" data-id="element-262" data-mp="3p7sybwxsms0t">
          {components.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08
        }} className="flex items-start gap-3 bg-cream-light border border-line rounded-xl p-5 shadow-sm" data-id="element-263" data-mp="3k86jxk68b5qf" data-mpi={i}>
              <span className="text-gold-dark text-lg leading-none mt-0.5" aria-hidden="true" data-id="element-264" data-mp="35hyxyuh0j4kz">
                ✦
              </span>
              <span className="text-ink-soft text-sm leading-relaxed" data-id="element-265" data-mp="2wjn84unz0atl">
                {item}
              </span>
            </motion.div>)}
        </div>

        <p className="text-center text-ink-soft mt-10 max-w-3xl mx-auto leading-relaxed" data-id="element-266" data-mp="2rmepksywu4rt">
          Every component was built to complement the others. Nothing is filler.
          Nothing overlaps. Together, they give you everything you need to run a
          complete, professional hip hop dance program —{' '}
          <span className="text-burgundy font-semibold" data-id="element-267" data-mp="23wx0qtf1dpy8">
            from day one to showcase day.
          </span>
        </p>
      </div>
    </section>;
}